import { ButtonBase, Stack } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

type Props = PropsWithChildren & {
	hasDivider: boolean;
	onClick: () => void;
};

export const SolutionRow: FC<Props> = ({ hasDivider, onClick, children }) => (
	<Stack
		component={ButtonBase}
		direction="row"
		alignItems="center"
		justifyContent="flex-start"
		textAlign="left"
		width="100%"
		gap={1.2}
		px={1.6}
		py={1.2}
		borderBottom={hasDivider ? 1 : 0}
		borderColor="divider"
		onClick={onClick}
	>
		{children}
	</Stack>
);
